/** Backend feature keys (snake_case) — single source for selectors & UI gates */
export const AGENT_FEATURE_KEYS = {
  /** סיכום חיוב צפוי / פירוט פיננסי בדשבורד ניהול */
  BILLING_ACCESS: "billing_access",
  /** אתר סוכן ציבורי + הגדרות אתר */
  AGENT_PUBLIC_SITE: "agent_public_site",
  SEARCH_HOTELS: "search_hotels",
  SEARCH_PACKAGES: "search_packages",
  SEARCH_FLIGHTS: "search_flights",
  ORGANIZED_TOURS: "organized_tours",
  /** HR margin למאורגנים ב-LDS pricing (parity BE organized_tour_hr_commission_percentage) */
  ORGANIZED_TOUR_HR_COMMISSION_PERCENTAGE: "organized_tour_hr_commission_percentage",
  DYNAMIC_PACKAGES: "dynamic_packages",
  PRIORITY_SUPPORT: "priority_support",
  /** אחוז פיצול דמי טיפול (handling) סוכן/חברה — לא אחוז על מחיר עסקה כולל או net ספק. ראו handling_fee_commission ב-BE. */
  COMMISSION_PERCENTAGE: "commission_percentage",
  /** Fallback HR margin when category-specific features are unset; also default bucket for non-vacation/non-flight LDS. */
  HOTEL_HR_COMMISSION_PERCENTAGE: "hotel_hr_commission_percentage",
  VACATION_PACKAGE_HR_COMMISSION_PERCENTAGE: "vacation_package_hr_commission_percentage",
  FLIGHT_HR_COMMISSION_PERCENTAGE: "flight_hr_commission_percentage",
  MAX_MONTHLY_ORDERS: "max_monthly_orders",
  LEADS_SYSTEM: "leads_system",
  SEO_SYSTEM: "seo_system",
  SMART_QUOTES: "smart_quotes",
  /** AI Sales + Inbox צ'אט — ב-DB: crazy_llama (package_feature_values). */
  AI_SALES: "crazy_llama",
  CRAZY_LLAMA: "crazy_llama",
  HOTEL_PREBOOKING: "hotel_prebooking",
  TEAM_MANAGEMENT: "team_management",
  REFERRAL_REWARDS: "referral_rewards",
  MONTHLY_PRICING: "monthly_pricing",
  CUSTOMER_OFFER_LINK: "customer_offer_link",
  MULTI_PACKAGE_CUSTOMER_OFFER: "multi_package_customer_offer",
  /** הצעות מנו ספנות + דרכונים — מנו */
  MANO_QUOTES: "mano_quotes",
};
